import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Tweens } from "../Components/Effects/Tweens";
import { Reel } from "../GameComponents/Reel";
import { Settings } from "./Settings";
import { Symbol } from "../GameComponents/Symbol";

/**
 * Class reel represent reel symbols rotationExtension of original Reel class.
 * @extends ReelExtended
 */
@engineComponent(ComponentTypes.DisplayObject)
export class ReelExtended extends Reel {
    public spinStop(force: boolean = false, customDelay: number = 0): void {
        if (force) {
            this.isTeasing = false;
            this.teasingSymbols = [];
        }

        super.spinStop(force, customDelay);
    }

    /**
     *
     */
    protected spinPreRoll(): void {
        if (this.currentSymbols[0] != null) {
            Tweens.alphaTween(this.currentSymbols[0], {
                alphas: [0, 1],
                tweenDuration: this.preRollSpeed,
            });
        }

        if (this.currentSymbols[4] != null) {
            Tweens.alphaTween(this.currentSymbols[4], {
                alphas: [0, 1],
                tweenDuration: this.preRollSpeed,
            });
        }

        for (let i = this.symbolBottomCount; i < this.symbolBottomCount + this.symbolCount; i++) {
            const symbol = this.currentSymbols[i];

            if (symbol.id === Settings.SymbolDragonsGate) {
                symbol.visible = false;
            }
        }

        Tweens.removeTweens(this, "position");
        Tweens.positionTween(this, {
            tweenX: [this.positionX, this.positionX, this.positionX],
            tweenY: [this.positionY, this.positionY - this.preRoll, this.positionY],
            tweenDuration: this.preRollSpeed * 2,
            tweenDelay: this.startDelay,
            callbackFunction: this.spinRoll,
            callbackScope: this,
        });
    }

    /**
     *
     */
    protected spinRoll(): void {
        for (let i = this.symbolBottomCount; i < this.symbolBottomCount + this.symbolCount; i++) {
            this.currentSymbols[i].visible = true;
        }

        if (this.currentSymbols[0] != null) {
            Tweens.removeTweens(this.currentSymbols[0], "alpha");
        }

        if (this.currentSymbols[4] != null) {
            Tweens.removeTweens(this.currentSymbols[4], "alpha");
        }

        Tweens.removeTweens(this, "position");
        Tweens.positionTween(this, {
            tweenX: [this.positionX, this.positionX],
            tweenY: [this.positionY, this.positionY + this.symbolHeight],
            tweenDuration: this.rollSpeed,
            callbackFunction: this.updateReel,
            callbackScope: this,
        });
    }

    //******************************************************************************************************************
    //  SPIN POST ROLL
    //******************************************************************************************************************

    protected spinPostRoll(): void {
        if (this.currentSymbols[0] != null) {
            Tweens.alphaTween(this.currentSymbols[0], {
                alphas: [1, 0],
                tweenDelay: this.postRollSpeed,
                tweenDuration: this.postRollSpeed,
            });
        }

        if (this.currentSymbols[4] != null) {
            Tweens.alphaTween(this.currentSymbols[4], {
                alphas: [1, 0],
                tweenDuration: this.postRollSpeed * 2,
            });
        }

        super.spinPostRoll();
    }

    //******************************************************************************************************************
    //  SPIN COMPLETE
    //******************************************************************************************************************

    protected spinComplete(): void {
        if (this.currentSymbols[0] != null) {
            Tweens.removeTweens(this.currentSymbols[0], "alpha");
        }

        if (this.currentSymbols[4] != null) {
            Tweens.removeTweens(this.currentSymbols[4], "alpha");
        }

        super.spinComplete();
    }

    protected getSymbol(symbolId: number, symbolCase: string): Symbol {
        const symbol = super.getSymbol(symbolId, symbolCase);

        if (
            this.isTeasing &&
            symbol.getCurrentCase() === Symbol.CaseBlur &&
            this.teasingSymbols.indexOf(symbol.id) === -1
        ) {
            symbol.goToCase(Symbol.CaseNowinBlur);
            symbol.alpha = 0.6;
        }

        if (
            this.isTeasing &&
            symbol.getCurrentCase() === Symbol.CaseBlur &&
            this.teasingSymbols.indexOf(symbol.id) !== -1
        ) {
            symbol.goToCase(Symbol.CaseBlurTease);
        }

        return symbol;
    }

    protected returnSymbol(symbol: Symbol): void {
        symbol.alpha = 1;
        this.symbols.returnSymbol(symbol);
    }

    public setTease(isTeasing: boolean, teasingSymbols: Array<number> = null): void {
        this.isTeasing = isTeasing;
        this.teasingSymbols = teasingSymbols;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ReelExtended.ts
 **/